module.exports = __webpack_public_path__ + "static/img/record-zhiban.1e9d2d8d.jpg";